/**
 * Every user-facing string in the legend module. Override any subset via
 * `<Legend.Provider labels={{ … }}>` — pure `*UI` components also accept a
 * `labels` prop directly for store-free composition.
 */
export interface LegendLabels {
  // Layer row
  expandLayer: string
  collapseLayer: string
  hideLayer: string
  showLayer: string

  // Row overflow menu
  layerOptions: string
  zoomTo: string
  /** In-flight label for Zoom to layer / Zoom to group. */
  loading: string
  showOnlyLayer: string
  showAllLayers: string

  // Group
  hideGroup: string
  showGroup: string
  expandGroup: string
  collapseGroup: string

  // Group overflow menu
  groupOptions: string
  showOnlyGroup: string
  showAllGroups: string
  collapseAllGroups: string
  expandAllGroups: string
  zoomToGroup: string

  // Panel
  panelOptions: string
  /** Sticky header of the visible-layers summary; the count is appended. */
  enabledLayers: string
  /** Tooltip of the visible-layers summary trigger. */
  toggleEnabledLayers: string
  /** Tooltip shared by the ⋮ menu triggers (row, group and panel). */
  moreOptions: string
  /** Drag handle of sortable groups/rows (aria + tooltip). */
  reorder: string

  // Row controls
  opacity: string
  attribute: string
  /** Generic close affordance (e.g. the inline opacity bar's ✕). */
  close: string

  // Item renderers
  radiusRangeBy: string
  colorBasedOn: string
  colorGradient: string
  /** Prefix for the largest proportion break, e.g. `"MAX: "`. */
  maxPrefix: string
  /** Prefix for the smallest proportion break, e.g. `"MIN: "`. */
  minPrefix: string
}

export const DEFAULT_LEGEND_LABELS: LegendLabels = {
  expandLayer: 'Expand layer',
  collapseLayer: 'Collapse layer',
  hideLayer: 'Hide layer',
  showLayer: 'Show layer',

  layerOptions: 'Layer options',
  zoomTo: 'Zoom to layer',
  loading: 'Loading…',
  showOnlyLayer: 'Show only this layer',
  showAllLayers: 'Show all layers',

  hideGroup: 'Hide group',
  showGroup: 'Show group',
  expandGroup: 'Expand group',
  collapseGroup: 'Collapse group',

  groupOptions: 'Group options',
  showOnlyGroup: 'Show only this group',
  showAllGroups: 'Show all groups',
  collapseAllGroups: 'Collapse all groups',
  expandAllGroups: 'Expand all groups',
  zoomToGroup: 'Zoom to group',

  panelOptions: 'Legend options',
  enabledLayers: 'Enabled layers',
  toggleEnabledLayers: 'Quickly toggle enabled layers',
  moreOptions: 'More options',
  reorder: 'Reorder',

  opacity: 'Opacity',
  attribute: 'Attribute',
  close: 'Close',

  radiusRangeBy: 'Radius range by',
  colorBasedOn: 'Color based on',
  colorGradient: 'Color gradient',
  maxPrefix: 'MAX: ',
  minPrefix: 'MIN: ',
}
